<svg
  width="9"
  height="11"
  viewBox="0 0 9 11"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  [ngStyle]="overrideStyle"
>
  <path
    d="M7.55837 0.221924C7.02953 0.221924 6.6078 0.50308 6.64127 0.855641V9.58932C6.6078 10.4328 8.54911 10.4328 8.51564 9.58932V0.855641C8.51564 0.50308 8.09391 0.221924 7.55837 0.221924Z"
    fill="white"
  />
  <path
    d="M0.998098 0.221924C0.502728 0.221924 0.0809943 0.50308 0.0809943 0.855641V9.58932C0.0475234 10.4328 1.98884 10.4328 1.95537 9.58932V0.855641C1.98884 0.50308 1.52694 0.221924 0.998098 0.221924Z"
    fill="white"
  />
</svg>
